<template>
    <section class="plugin__category">
        <header>
            <div class="category__header">
                <h2 class="category__header--title">{{title}}</h2>
                <btn v-if="filterInfo" @click="toggleFilter(filterInfo, filterMeta)" :text="$t('page.home.view_all')" :class="'btn--ghost'" />
            </div>
            <div v-if="description" class="category__header--description">{{description}}</div>
        </header>
        <main>
            <template v-if="!plugins">
                <plugin-entry-placeholder
                    v-for="plugin in 3"
                    :key="plugin"></plugin-entry-placeholder>
            </template>
            <template v-else>
                <plugin-entry
                    v-for="plugin in plugins" 
                    :key="plugin.id"
                    :id="plugin.id"
                    :logo="plugin.image"
                    :size="128"
                    :title="plugin.name"
                    :short_description="plugin.short_description"
                    :technologies="plugin.technologies"
                    :brands="plugin.brands"
                    :rating="plugin.rating"
                    :highlight="plugin.highlight"
                    :certified="plugin.certified"
                    :creator="plugin.creator"
                    :type="plugin.type"></plugin-entry>
            </template>
        </main>
    </section>
</template>

<script>
import PluginEntry from '@/components/PluginEntry.vue';
import PluginEntryPlaceholder from '@/components/PluginEntryPlaceholder.vue';
import Btn from '@/components/Button.vue';
export default {
    name: 'PluginCategory',
	components: {
        PluginEntry,
        PluginEntryPlaceholder,
        Btn
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: false,
        },
        plugins: {
            type: Object,
            required: false,
        },
        filterInfo: {
            type: Object,
            required: false,
        },
        filterMeta: {
            type: Object,
            required: false,
        },
        orderInfo: {
            type: String,
            required: false,
        }
    },
    methods: {
        toggleFilter(filter, filtermeta){
            if(filtermeta.value == 'certification') {
                filter = '1';
                var filterby = 'certified';
                var isSelected = false;
                this.$store.dispatch('toggleFilter', {filter, filterby, isSelected});
            } else {
                var orderby = this.orderInfo;
                this.$store.state.currentFilters.custom = filtermeta;
                this.$store.state.pluginsFilter.custom = ['1'];
                this.$store.dispatch('loadFilteredPlugins', {filter, orderby});
            }
        },
    }

}
</script>

<style scoped>
    .plugin__category{
        padding: 20px 0;
    }
    .plugin__category header{
        padding-bottom: 25px;
    }
    .category__header{
        display: flex;
        justify-content: space-between;
    }
    .category__header--title{
        font-size: 30px;
        line-height: 40px;
        color: #000A12;
        font-weight: normal;
        vertical-align: middle;
        margin: 0;
    }

    .category__header--button{
        font-size: 16px;
        display: inline-block;
        box-sizing: border-box;
        border: 1px solid #000A12;
        color: #000A12;
        line-height: 30px;
        padding: 0 20px;
        cursor: pointer;
        margin: 4px 0;
    }

    .category__header--description{
        padding-top: 10px;
        font-size: 16px;
        line-height: 22px;
        color: #575C61;
    }
    main{
        display: grid;
        grid-template-columns: calc(calc(100% / 3) - calc(50px / 3)) calc(calc(100% / 3) - calc(50px / 3)) calc(calc(100% / 3) - calc(50px / 3));
        grid-column-gap: 25px;
    }
</style>